import API from "../../API";
import { showToast } from "../../Controllers/Toast";
import {
  GET_ALL_CUSTOMERS,
  GET_ALL_CUSTOMERS_FAILED,
  GET_ALL_CUSTOMERS_REQUEST,
  HANDLE_ERROR,
} from "../action.type";

export const getAllCustomers = (search, page, limit) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_ALL_CUSTOMERS_REQUEST,
      });
      const apiCall = await API({
        url: "/admin/pos/getCustomers",
        method: "get",
        params: { searchkey: search, page, limit },
      });
      if (apiCall?.status === 200 || apiCall?.status === 304) {
        dispatch({
          type: GET_ALL_CUSTOMERS,
          payload: apiCall?.data,
        });
      }
    } catch (error) {
      showToast.error(error);
      dispatch({
        type: HANDLE_ERROR,
        payload: error,
      });
      dispatch({
        type: GET_ALL_CUSTOMERS_FAILED,
      });
    }
  };
};
export const addCustomer = (data) => {
  return async (dispatch) => {
    try {
      const apiCall = await API({ url: `/admin/pos/addCustomer`, method: "post", data });
      if (apiCall?.status === 200 || apiCall?.status === 304) {
        dispatch(getAllCustomers());
        showToast.success("Customer Added Successfully!");
        return apiCall?.data;
      }
    } catch (error) {
      showToast.error(error);
      dispatch({
        type: HANDLE_ERROR,
        payload: error,
      });
    }
  };
};
export const updateCustomer = (id, data) => {
  return async (dispatch) => {
    try {
      const apiCall = await API({ url: `/admin/pos/updateCustomer/${id}`, method: "put", data });
      if (apiCall?.status === 200 || apiCall?.status === 304) {
        dispatch(getAllCustomers());
        showToast.success("Customer Update Successfully!");
      }
    } catch (error) {
      showToast.error(error);
      dispatch({
        type: HANDLE_ERROR,
        payload: error,
      });
    }
  };
};
